import React from 'react';
import './Attention.css';
import attentionIconImg from './attentionIcon.svg';

const Attention = ({ text, attentionClick }) => {

    return (
        <div onClick={attentionClick} className="attention-wrapper">
            <div className="attention-container">
                <span className="attention-text">{text}</span>
                <img src={attentionIconImg} alt="Attention Icon" className="attention-icon" id="attentionIcon" />
            </div>

        </div>
    );
}

export default Attention;
